export const LOADING_APP = "LOADING_APP";
export const TOGGLE_MOBILE_NAV = "TOGGLE_MOBILE_NAV";
export const TOGGLE_ICON_NAV = "TOGGLE_ICON_NAV";
export const TOGGLE_ICON_NAV_HOVER = "TOGGLE_ICON_NAV_HOVER";
export const TOGGLE_THEME_STATE = "TOGGLE_THEME_STATE";
export const TOGGLE_MOBILE_DROPDOWN = "TOGGLE_MOBILE_DROPDOWN";
